import * as angular from 'angular';
import {ConsolidatedCommissionRequestsService} from "./consolidated-commission-requests.service";
import {CommissionsAlertsService} from "./commissions-alerts.service";
import {ConsolidatedCommissionModel} from "../models/consolidated-commission.model";
import {ExportConsolidatedCommissionTablePayloadModel} from "../models/consolidated-commission-table-export-payload.model";
import {ExportConsolidatedCommissionsTranslationsPayloadModel} from "../types/export-consolidated-commissions-translations-payload.model";
import {IQService} from "angular";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";

export class ConsolidatedCommissionsService {

  constructor(private consolidatedCommissionRequestsService: ConsolidatedCommissionRequestsService,
              private commissionsAlertsService: CommissionsAlertsService,
              private $q: IQService, private bringozLoaderService: BringozLoaderService, private $log) {
  }

  getOne(id) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.consolidatedCommissionRequestsService.getOne(id)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        this.commissionsAlertsService.getOneError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  create(consolidatedCommissionPayload: ConsolidatedCommissionModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.consolidatedCommissionRequestsService.create(consolidatedCommissionPayload)
      .then((res) => {
        this.commissionsAlertsService.createSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.commissionsAlertsService.createError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  update(id, consolidatedCommission: ConsolidatedCommissionModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.consolidatedCommissionRequestsService.update(id, consolidatedCommission)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        // this.fulfillmentAlertsService.dispatchStepError(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  delete(id) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.consolidatedCommissionRequestsService.delete(id)
      .then((res) => {
        this.commissionsAlertsService.deleteSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.commissionsAlertsService.deleteSuccess();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  addCommissions(id, payload) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.consolidatedCommissionRequestsService.addCommissions(id, payload)
      .then((res) => {
        this.commissionsAlertsService.addCommissionsToConsolidatedSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.commissionsAlertsService.addCommissionsToConsolidatedError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  removeCommissions(id, commissionIds) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.consolidatedCommissionRequestsService.removeCommissions(id, commissionIds)
      .then((res) => {
        this.commissionsAlertsService.removeCommissionsFromConsolidatedSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.commissionsAlertsService.removeCommissionsFromConsolidatedError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  payManually(id, commissionPaymentDetails) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.consolidatedCommissionRequestsService.payManually(id, commissionPaymentDetails)
      .then((res) => {
        this.commissionsAlertsService.PayConsolidatedManuallySuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.commissionsAlertsService.PayConsolidatedManuallyError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  pay(id, commissionPaymentDetails) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.consolidatedCommissionRequestsService.pay(id, commissionPaymentDetails)
      .then((res) => {
        this.commissionsAlertsService.PayConsolidatedManuallySuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.commissionsAlertsService.PayConsolidatedManuallyError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  exportTableCSV(payload: ExportConsolidatedCommissionTablePayloadModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.consolidatedCommissionRequestsService.exportTableCSV(payload)
      .then((response) => {
        this.commissionsAlertsService.exportSuccess();
        deferred.resolve(response);
      })
      .catch((error) => {
        this.commissionsAlertsService.exportError();
        this.$log.error('Failed to export consolidated CSV', error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  exportCSV(consolidatedId, payload: ExportConsolidatedCommissionsTranslationsPayloadModel, zoneId?) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.consolidatedCommissionRequestsService.exportCSV(consolidatedId, payload, zoneId)
      .then((response) => {
        this.commissionsAlertsService.exportSuccess();
        deferred.resolve(response);
      })
      .catch((error) => {
        this.commissionsAlertsService.exportError();
        this.$log.error('Failed to export consolidated CSV', error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }


}

angular
  .module('bringoz.admin.commissions')
  .service('consolidatedCommissionsService', ConsolidatedCommissionsService);
